import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SetField } from '../components/Table/fields/SetField';
import { SPSetField2 } from '../components/Table/fields/SPSetField2';

export const userByRole = (role: string): SchemaWithClient<any> => {
  return {
    name: 'User',
    pluralName: 'User',
    tabs: [
      {
        id: 1,
        label: 'General',
        name: 'general',
      },
    ],
    columns: {
      name: {
        name: 'Name',
        required: true,
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      email: {
        name: 'Email',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      full_name: {
        name: 'Full Name',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      phone: {
        name: 'Phone',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      alternative_phone: {
        name: 'Phone',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      ssn_number: {
        name: 'SSN Number',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      roles: {
        name: 'User Type',
        fieldRenderer: SetField.tableAdapter(enumItems.userType),
        slidePaneFieldRenderer: SPSetField2.tableAdapter(enumItems.userType),
        multiSwitchboard: true,
        url: enumItems.userType.client.getAllPath,
        tempSchema: enumItems.userType,
      },
      sub_roles: {
        name: 'Sub Roles',
        fieldRenderer: SetField.tableAdapter(enumItems.subRole),
        slidePaneFieldRenderer: SPSetField2.tableAdapter(enumItems.subRole),
        multiSwitchboard: true,
        url: enumItems.subRole.client.getAllPath,
        tempSchema: enumItems.subRole,
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client(`/admin/users-by-role/${role}`),
  };
};
